import { lazy } from 'react';
import { Route } from 'react-router-dom';
import { LazyRoute } from './LazyRoute';

const JoinPage = lazy(() => import('@/features/student-auth/pages/JoinPage'));
const ChooserPage = lazy(() => import('@/features/student-auth/pages/ChooserPage'));

// Public (unauthenticated) routes for kid device sign-in.
// A kid on a fresh device has no auth yet, so these must live OUTSIDE the
// ProtectedRoute tree.
export const studentAuthRoutes = (
  <>
    <Route path="/join" element={<LazyRoute fallbackMessage="Loading..."><JoinPage /></LazyRoute>} />
    <Route path="/kid" element={<LazyRoute fallbackMessage="Loading..."><ChooserPage /></LazyRoute>} />
  </>
);
